/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/kunde-bonuspunkt.ts.
 */
import {Bonuspunktprogramm} from './bonuspunktprogramm';

/**
 * Zweck: Beschreibt class KundeBonuspunkt und ihren Daten- oder Funktionsvertrag.
 */
export class KundeBonuspunkt {
  Kundennummer: number;
  Kundenart: string;
  Bonuspunkteprogramm: Bonuspunktprogramm;
  BonuspunkteprogrammAktiv: boolean;
  Bonuspunkte: number;

  // GUI
  prozent: string;
  level: number;
  ptonextlevel: number;
}
